import { Container } from "./Container"

export const Filter = {
    Container
}